import React, { Component } from 'react';
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import {
  SearchProvider,
  WithSearch,
  Paging,
  PagingInfo,
  ResultsPerPage,
  ErrorBoundary,
  Sorting,
  Facet,
  SearchBox
} from "@elastic/react-search-ui";
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {
  Layout,
  MultiCheckboxFacet,
  BooleanFacet
} from "@elastic/react-search-ui-views";
import CustomFacet from "./CustomFacet";
import MultiCheckboxFacetCommon from "./MultiCheckBoxFacetCommon";
import MultiCheckboxFacetTrans from "./MultiCheckBoxFacetTrans";

import "@elastic/react-search-ui-views/lib/styles/styles.css";

import Grid from "@material-ui/core/Grid";
import AppBar from "@material-ui/core/AppBar";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from "@material-ui/core/styles";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';
import axios from 'axios';

import App from './App';
import FamilySelector from './FamilySelector';
import ResetButton from './ResetButton';
import ShareButton from './ShareButton';
import SelectedFilters from './SelectedFilters';
import SelectedFiltersComp from './SelectedFiltersComp';
import TopBanner from './TopBanner';
import IndpCommentComponent from './IndpCommentComponent';
import IndpNewTask from './IndpNewTask';

import configData from "../../../config.json";
import FiltersMenu from './FiltersMenu';
import PriceSortingSelector from './PriceSortingSelector';
import ErrorBoundaryView from './ErrorBoundaryView';
import SearchBanner from './SearchBanner';
import IconButton from '@material-ui/core/IconButton';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import FormatListNumberedRtlIcon from '@material-ui/icons/FormatListNumberedRtl';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import EventEmitter from '../event';
import { config } from 'react-transition-group';
import { languageId } from './partials/constants';
var mainH = 0;


const styles = theme => ({
  formControl: {
    minWidth: 50,
  },
  labelZIndez: {
    "z-index": 0
  }
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div {...other}>
      {value === index && <div>{children}</div>}
    </div>
  );
}

class ResultsRenderer extends Component {
  constructor(props) {
    
    super(props);
    
    this.state = {
      // selected product
      //New State should be available Where AppSearchbar is called 
      selectedProduct: {},
      sorting_filter_data: 'stock',
      filterClass: false,
      lang: this.props.lang,
      shop_id: this.props.shop_id,
      logged: this.props.logged,
      express: this.props.express,
      tariff: this.props.tariff,
      family_list: this.props.family_list,
      family_friend_list: this.props.family_friend_list,
      label_list: this.props.label_list,
      family: this.props.family,
      offers: this.props.offers,
      trackUrlState: this.props.trackUrlState,
      friend_filters: this.props.friend_filters,
      family_filters: this.props.family_filters,
      show_filters: true,
      price_sort: this.props.price_sort || 'no_filter',   
      familySortOnInit: this.props.familySortOnInit || false,
      current_page: 1,
      typeView: 'grid',
      width: 0,
      banner: this.props.banner,
      customFilterManufacturer: this.props.customFilterManufacturer,
      customFilterManufacturerIds: this.props.customFilterManufacturerIds,
      client_country_id: this.props.client_country_id,
      cart_products: this.props.cart_products,
      fav_products: this.props.fav_products,
      jwt: this.props.jwt,
      api_url: this.props.api_url,
      bannerList: this.getBanners() || [],      
      config: {
        alwaysSearchOnInitialLoad: true,
        trackUrlState: this.props.trackUrlState,

        apiConnector: new AppSearchAPIConnector({
          searchKey: this.props.searchKey || configData.searchKey,
          engineName: (this.props.family == "" || this.props.family == null) ? configData.engineName + "-" + this.props.shop_id : configData.engineName + "-" + this.props.shop_id + "-" + this.props.family,
          endpointBase: this.props.endpointBase || configData.endpointBase
        }),
        initialState: this.props.friend_filters,          
        
        searchQuery: {          
          /*TESTfilters: [
            { field: "invisible", values: ["false"] }
          ],*/
          precision:5, /* https://www.elastic.co/guide/en/app-search/current/precision-tuning.html */
          disjunctiveFacets: ["manufacturer",'lg_1'],
          facets: {
            manufacturer: { type: "value", size: 250 },
            main_color: { type: "value" },
            /*TEST in_offer: { type: "value" },*/
            not_discontinued: { type: "value" },
            /*TEST is_knx: { type: "value" },
            in_showroom: { type: "value" },*/
            common: { type: "value", size: 10 },
            color: { type: "value", size: 250 },
            manufacturer_series: { type: "value", size: 250 },
            price_group: { type: "value", size: 250 },
            /*lg_1: { type: "value", size: 50 }*/
            /*TEST stock: {
              type: "range",
              ranges: [
                { from: 1, name: "In stock" }
              ]
            },*/
          }         
        },
        autocompleteQuery: {
          suggestions: {
            types: {
              documents: { fields: ["multilingual_autoname"] }
            },
            size:20
          }
        }
      },
      search_dropdown: "text",
      sorting_dropdown: "desc",
      value: 1,
      isFamilyFlag: false,
      searchMode: "text",
      mainHeightSec: 0,
      height: 0,
      dimensions: null,
      isFlag:true,
      inputRef:[]
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.openSearchBlock = this.openSearchBlock.bind(this);
    this.openPinBlock = this.openPinBlock.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
    this.addFilterClass = this.addFilterClass.bind(this);
    this.handleClickAway = this.handleClickAway.bind(this);
    this.showHideFilters = this.showHideFilters.bind(this);
    this.hideSidebarFilter = this.hideSidebarFilter.bind(this);
    this.handleDirectionChange = this.handleDirectionChange.bind(this);
    this.handlePriceSorting = this.handlePriceSorting.bind(this);
    this.handleClickChange = this.handleClickChange.bind(this);
    this.submitData = this.submitData.bind(this);
    this.onChangeGetName = this.onChangeGetName.bind(this);
    this.handleClickClearChange = this.handleClickClearChange.bind(this);
    this.onSortingChange = this.onSortingChange.bind(this);
    this.mainSectionHeight = this.mainSectionHeight.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.eventEmitter();
  }
  
 /**
  * Add to cart Event
  * @param {product} product 
  */
  onProductAddedToCart = (product) => {
    console.log("Product Added to cart:", product);
  };

  /**
   * Cart qty change Event
   * @param {product}  
   */
  onProductQtyModifiedOnCart = (product) => {
    console.log("product qty changed: ", product);
  };

  // Cart product delete Event
  onProductDeletedFromCart = (product) => {
    console.log("product deleted from cart", product);
  };

  // Product Add to List Event 
  onProductAddedToList = (product) => {
    console.log("added to list", product);
  };

// Product selecte event 
  handleProductSelected = (product) => {
    console.log(product);
    this.setState({ selectedProduct: product });
  };

  // Delete select product event 
  onProductDeleted = (code)=> {
   console.log("onProductDeleted: code ",code);
 }
  
  eventEmitter = () => {
    EventEmitter.subscribe('heightMainSection', (data) => {
      if (data !== mainH) {
        mainH = data;
        this.forceUpdate();
      }
    })
  }

   getBanners = (manufacturer_id = "", family_id = this.props.family) => {
    var manufacturer_name = '';
    
    if(typeof this.props.friend_filters !== undefined 
      && typeof this.props.friend_filters.filters !== undefined
      && this.props.friend_filters.filters.length>0
      && typeof this.props.friend_filters.filters.length[0] !== undefined
      && typeof this.props.friend_filters.filters[0].field !== undefined) {
      if(this.props.friend_filters.filters[0].field=='manufacturer') {
        //manufacturer_name=this.props.friend_filters.filters[0].values[0];
        console.log('manu/dis', this.props.friend_filters.filters[0].values[0]);
        manufacturer_name = this.props.friend_filters.filters[0].values[0];
      }
    }
    if(manufacturer_name!='')  {
    axios.get(`/php/getBanners.php?manufacturer_name=${manufacturer_name}&manufacturer_id=${manufacturer_id}&family_id=${family_id}`)
      .then(res => {
        // console.log('res11:',res);
        if (res.status === 200) {          
          this.setState({ bannerList: res.data })
        }
      })
    }
    else {
      axios.get(`/php/getBanners.php?manufacturer_id=${manufacturer_id}&family_id=${family_id}`)
      .then(res => {
        // console.log('ress22:',res);
        if (res.status === 200) {          
          this.setState({ bannerList: res.data })
        }
      })
    }

  }
  

  onChangeGetName = (e) => {
    if (e == "main_family|||asc" || e == "main_family|||desc") {
      this.setState({
        isFamilyFlag: true
      })
    } else {
      this.setState({
        isFamilyFlag: false
      })
    }
  }

  handleClickChange(clearFilters,SearchTerm) {
    const { config,family,trackUrlState } = this.state;
    let change = false;
    if (family != "") {
      change = true;
    }
    /*
        config.apiConnector= new AppSearchAPIConnector({
          searchKey: configData.searchKey,
          engineName: configData.engineName + "-" + this.props.lang,
          endpointBase: configData.endpointBase
        });
      */
    config.searchQuery.search_fields = {
      id: {}
    };

    clearFilters();
    this.setState({
      family: this.state.family = "",
      searchMode: this.state.searchMode = "id",
      value: this.state.value = 0
    })
//console.log('SearchTerm:::', SearchTerm)

    var url = new URL(window.location.href);
    url.searchParams.set('engine', "");
    url.searchParams.set('search_mode', "id");
    window.history.replaceState(null, null, url);

    //if(change) 
    {
      axios.post('/familysession.php', {
        family: ""
      })
      .then(function (response) {
         // Cambiar a engine genérico si se busca por cod_web
          let newurl = "";
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          let query = urlParams.get('q');
         if(trackUrlState) {
          newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + (q!=null?"?q=" + query:"") + "&search_mode=id" + "&engine=";
         }else {
          newurl = window.location.protocol + "//" + window.location.host + "/search" + (SearchTerm!=''?"?q=" + SearchTerm:"") + "&search_mode=id";
         }
         window.history.pushState({ path: newurl }, '', newurl);
         if(change) {
           //if(trackUrlState)
              location.reload();
         }
      })
      .catch(function (error) {
        //
      });
    }


  };

  handleClickClearChange(clearFilters, addFilter) {
    const { family, config } = this.state;
    this.setState({
      family: this.state.family = "",
      searchMode: this.state.searchMode = "text",
      value: this.state.value = 1
    })


    /*config.apiConnector= new AppSearchAPIConnector({
      searchKey: configData.searchKey,
      engineName: (this.props.family == "" || this.props.family == null) ? configData.engineName + "-" + this.props.lang : configData.engineName + "-" + this.props.family + "-" + this.props.lang,
      endpointBase: configData.endpointBase
    });*/
    delete config.searchQuery.search_fields;

    clearFilters();
    const url = new URL(window.location.href);
    url.searchParams.set('search_mode', "text");
    url.searchParams.set('engine', "");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const category = urlParams.get('category');
    if (category != "id") {
      addFilter("not_discontinued", "true", "any");
      // addFilter("main_color", "true", "any");
    }
    window.history.replaceState(null, null, url);
  }

  onChange(event) {
    //Aqui
    
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeView(typeView) {
    this.setState({
      typeView: typeView
    });
    this.handleView(typeView);
  }

  /*
  onChangeCategory(event) {
    let { config, family,trackUrlState } = this.state;

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    let query = urlParams.get('q');

    
    delete config.searchQuery.search_fields;
    

    this.setState({
      [event.target.name]: event.target.value,
      config: config
    });

    if (event.target.value == "id" && !(family == "" || family == null || family == undefined)) {
      if (query == null || query == undefined) {
        query = "";
      }

      // Actualiza la familia en PHP
      axios.post('/familysession.php', {
        family: ""
      })
        .then(function (response) {
          // Cambiar a engine genérico si se busca por cod_web
          let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?q=" + query + "&category=id" + "&engine=";
          window.history.pushState({ path: newurl }, '', newurl);
          if(trackUrlState)
            location.reload();
        })
        .catch(function (error) {
          //
        });
    }
  }
*/
  handleDirectionChange(event, sortField, setSort) {
    const { config } = this.state;
    this.setState({ [event.target.name]: event.target.value });
    config.initialState.sortDirection = event.target.value
    setSort(sortField, event.target.value);
  }

  handleFilterVisibility() {
    let { show_filters } = this.state;
    if (show_filters) {
      this.setState({ show_filters: false });
    }
    else {
      this.setState({ show_filters: true });
    }
  }

  handlePriceSorting = (price_sort, current_page) => {

    this.setState({
      price_sort: price_sort,
      current_page: current_page
    });
  }

  handleView = (typeView) => {
    this.setState({ typeView: typeView });
  }

  componentDidMount() {
    if(this.state.inputRef.length > 0) {
      var lastEl = this.state.inputRef.slice(-1)[0]
      this.setState({
        dimensions: {
          width: lastEl?.clientWidth,
          height: lastEl?.clientHeight,
        },
      });
    }
    
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    document.body.classList.add('checkBTn2');
    // document.querySelector('.sidebar-toggle-close').addEventListener("click",this.menuClick);

    let { config, family, trackUrlState } = this.state;

    this.changeLanguage(this.state.lang);
    i18n.addResourceBundle(this.state.lang,'translation',this.props.labels[this.state.lang],true,true);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.get('sort-direction')) {
      this.setState({
        sorting_dropdown: urlParams.get('sort-direction')
      })
    }

    if (urlParams.get('view')) {
      this.setState({
        typeView: urlParams.get('view')
      })
    }

    if (urlParams.get('search_mode')) {
      if (urlParams.get('search_mode') == "id") {

        config.searchQuery.search_fields = {
          id: {}
        };
        this.setState({
          searchMode: urlParams.get('search_mode'),
          value: this.state.value = 0
        })
      } else {
        delete config.searchQuery.search_fields;
        this.setState({
          searchMode: urlParams.get('search_mode'),
          value: this.state.value = 1
        })
      }
    }

    const query = urlParams.get('q');
    let engine = urlParams.get('engine');
    const category = urlParams.get('category');

    if (family == null || family == undefined) {
      family = "";
    }
    if (engine == null || engine == undefined) {
      engine = "";
    }

    

    // Comprueba el engine al que pertenece la query si no coincide, la actualiza y recarga la web
    if (family != engine) {
      if (engine != family) {
        axios.post('/familysession.php', {
          family: engine
        })
          .then(function (response) {
            if(trackUrlState)
              location.reload();
          })
          .catch(function (error) {
            //
          });
      }
    }


    // Comprueba si la query solo contiene caracteres númericos, si se cumple, aplica el filtro de id
    /*if (category == "id") {
      config.searchQuery.search_fields = {
        id: {}
      };

      this.setState({
        config: config,
        search_dropdown: "id"
      });
    }*/
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  // menuClick = e => {
  //   document.querySelector('body').style = 'overflow: hidden';
  // };

  /**Función para el cambio de idioma de la aplicación. */
  changeLanguage(lng) {
    i18n.changeLanguage(lng)
  }

  openSearchBlock(id) {
    const ele = document.getElementById(id);
    if (ele.classList.contains('searching-filter-open')) {
      ele.classList.remove('searching-filter-open')
    } else {
      ele.classList.add('searching-filter-open')
    }
    if (ele.classList.contains('pin-filter')) {
      //if(localStorage.getItem('pinStatus') == null || localStorage.getItem('pinStatus') == true) {
        localStorage.setItem('pinStatus','closed');
      //}
      ele.classList.remove('pin-filter')
    }
  }

  handleClickAway = () => {
    const ele = document.getElementById('searchBlock');
    if (ele.classList.contains('searching-filter-open')) {
      ele.classList.remove('searching-filter-open')
    }
    {/* if (ele.classList.contains('pin-filter')) {
      ele.classList.remove('pin-filter')
    } */}
  };

  openPinBlock(id) {
    const ele = document.getElementById(id);

    if (ele.classList.contains('pin-filter')) {
      //if(localStorage.getItem('pinStatus') == null || localStorage.getItem('pinStatus') == true) {
        localStorage.setItem('pinStatus','closed');
      //}
      //localStorage.removeItem('pinStatus');
      ele.classList.remove('pin-filter');
    } else {
      localStorage.setItem('pinStatus', 'open');
      ele.classList.add('pin-filter');
    }
  }

  hideSidebarFilter = () => {
    document.querySelector('.sui-layout-sidebar').classList.remove('sui-layout-sidebar--toggled');
  }

  addFilterClass = () => {
    this.setState({
      filterClass: true
    })
  }

  showHideFilters = () => {
    this.setState({
      filterClass: false
    })
  }

  //Avoid search on enter
  onKeyPress = (event,setSort) => {
    if(event.key === 'Enter'){
      event.preventDefault();
      
    }
    else {
      
      /*if(this.state.familySortOnInit) {
        const { config } = this.state;            
          config.initialState.sortDirection = "asc";
          config.initialState.resultsPerPage = "asc";
          config.initialState.sortField = "";
          
          this.setState({
            sorting_dropdown: 'desc',
            price_sort: 'no_filter',
            current_page: 1,
            config,
            familySortOnInit: false
          });
          setSort('', 'desc');                
      }*/
    }    
  }

  handleSearch = (value, searchAsYouType) => {
    const sanitizedValue = value.replace(/-/g, '');
    searchAsYouType(sanitizedValue);
  };
  
  handleSelect = (query) => {
    const exactQuery = '"'+query.suggestion+'"';
    // Aquí es donde enviarías la exactQuery a Elasticsearch
    const sanitizedValue = exactQuery.replace(/-/g, '');
    searchAsYouType(sanitizedValue);
   };

  //When search button pressed
  submitData = (clearFilters, addFilter, setSort, SearchTerm) => {
    const { family, config, trackUrlState } = this.state;
    
    //aux variable to know if actual family is different than main engine
    let changed=(family!="");

    
    //Set default sort
    config.initialState.sortDirection = "asc";
    config.initialState.resultsPerPage = "asc";
    config.initialState.sortField = "";
    
    
    setSort("", "asc");
    
    //Save State
    this.setState({
      family: this.state.family = "",
      sorting_dropdown: "asc",
      config
    })

     //Clean all filters
     clearFilters();

    //If search by text
    if (this.state.value === 1) {
      //add default text filter
      addFilter("not_discontinued", "true", "any");
    } 
    
    //if trackUrlState then update url
    if(trackUrlState) {
      const url = new URL(window.location.href);
      url.searchParams.set('engine', "");
      window.history.replaceState(null, null, url);
      //Finally if engine-family change we realod
      if(changed) {
        location.reload();
      }
    }
    else {
      //friend url
      
      if (SearchTerm.startsWith('"') && SearchTerm[SearchTerm.length - 1] === '"') {
        // Usar slice() para eliminar el primer y último carácter
        SearchTerm=SearchTerm.slice(1, -1);      
      }
      window.location.assign(window.location.origin+"/search/"+(SearchTerm!=''?"?q="+SearchTerm:""));

    }

    
  }

  onSortingChange = (id, sortField, setSort, direction) => {
    if (id == "change") {
      const { config } = this.state;
      config.initialState.sortDirection = direction;
      setSort(sortField, direction);
      this.setState({
        sorting_dropdown: direction
      })
    }
  }

  setDefaultOrder = (setSort) => {
    const { config } = this.state;            
    config.initialState.sortDirection = "asc";
    config.initialState.resultsPerPage = "asc";
    config.initialState.sortField = "";
    
    this.setState({
      sorting_dropdown: 'desc',
      price_sort: 'no_filter',
      current_page: 1,
      familySortOnInit: false,
      config      
    });
    setSort('', 'desc'); 
  }

  mainSectionHeight = (height) => {
    this.setState({
      mainHeightSec: this.state.mainHeightSec = height
    })
  }


  componentDidUpdate() {
    if(this.state.isFlag) {
      if(this.state.inputRef.length > 0) {
        var lastEl = this.state.inputRef.slice(-1)[0]
        this.setState({
          isFlag: false,
          dimensions: {
            width: lastEl?.clientWidth,
            height: lastEl?.clientHeight,
          },
          inputRef: [],
        });
      }
    }    

  }

  setRef = (ref) => {    
    if(this.state.isFlag) {
      this.state.inputRef.push(ref);
    }
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;
    const { width, config, dimensions, lang, logged, filterClass, express, mainHeightSec, search_dropdown, isFamilyFlag, height, sorting_dropdown, typeView, tariff, family_list,family_friend_list, family, family_filters, label_list, show_filters, price_sort, current_page, trackUrlState, banner, customFilterManufacturer, customFilterManufacturerIds, client_country_id, cart_products, fav_products, jwt, api_url, api_origin,selectedProduct, familySortOnInit } = this.state;
    const f_name = Object.entries(family_list).map(([key, value]) => ({ key, value }));
    var familyName;
    if (family) {
      f_name?.length > 0 && (
        f_name.map((f) => {
          if (f.key == family) {
            familyName = (f.value).toLowerCase();
          }
        })
      )
    }

    const sort_options = [
      {
        name: t("Relevance"),
        value: "",
        direction: config.initialState.sortDirection
      },
      {
        name: t("Priority"),
        value: "topsales",
        direction: config.initialState.sortDirection
      },
      {
        name: t("Manufacturer"),
        value: "manufacturer",
        direction: config.initialState.sortDirection
      },
      {
        name: t("Reference"),
        value: "ref1",
        direction: config.initialState.sortDirection
      },
      /*{
        name: t("Stock"),
        value: "stock",
        direction: config.initialState.sortDirection
      },*/
      {
        name: t("Web Code"),
        value: "webcode",
        direction: config.initialState.sortDirection
      },
      {
        name: t("Name"),
        value: "autonames", 
        direction: config.initialState.sortDirection
      },
      {
        name: t("Age"),
        value: "entry_date",
        direction: config.initialState.sortDirection
      },
      {
        name: t("Family"),
        value: "main_family",
        direction: config.initialState.sortDirection
      }
    ];
        // return (
        //   <IndpCommentComponent 
        //    /> 
        // )

    return (
      <div className='results-renderer'>
        <SearchProvider config={config}>
        <WithSearch
          mapContextToProps={({ results, wasSearched, setSort, sortDirection, sortField, addFilter, 
            clearFilters, removeFilter, current, setCurrent, resultSearchTerm,facets }) => 
            ({
            results,
            wasSearched,
            setSort,
            sortDirection,
            sortField,
            addFilter,
            clearFilters,
            removeFilter,
            current,
            setCurrent,
            resultSearchTerm,
            facets
            
          })}
        >
          
          {({ results, wasSearched, setSort, sortDirection, sortField, addFilter, clearFilters, removeFilter, current, setCurrent, resultSearchTerm,facets }) => (
            <div className="App">
              <ErrorBoundary
                view={ErrorBoundaryView}
              >
                <div className="main-heading">
                  <h2 className="buy-heading">
                    <Trans>The most comprehensive KNX catalogue with</Trans> <span> <Trans>20.000 available products</Trans></span>
                  </h2>
                </div>
                <Layout
                  className={filterClass ? "sui-layout-buy hide-filters" : "sui-layout-buy"}
                  header={
                    <div className="sui-layout-header-row">
                      <div className="SearchBar">
                        <Grid container>
                          {/*<Grid key={"selectCategory"} className="searchbar-left" item sm={2}>
                            <FormControl variant="outlined" className={`${classes.formControl} form-control`}>
                              
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={search_dropdown}
                                onChange={(e) => this.onChangeCategory(e)}
                                // label={t("Category")}
                                name="search_dropdown"
                              >
                                <MenuItem value={"text"}>{t("Text")}</MenuItem>
                                <MenuItem value={"id"}>{t("Web Code")}</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>*/}
                          <Grid className="search-tab-wrapper">
                            <div className="search-tab-header">
                              <div className="search-label"><Trans>Searching in</Trans>:</div>
                              <AppBar position="static" className="tab-heading">
                                <Tabs value={this.state.value} >
                                  <Tab label={t("Web Code")} onClick={() => this.handleClickChange(clearFilters,resultSearchTerm)} />
                                  <Tab label={this.state.value === 0 ? t("Text/Ref./Keywords") : familyName ? familyName : t("all families")} onClick={() => this.handleClickClearChange(clearFilters, addFilter)} />
                                </Tabs>
                              </AppBar>
                            </div>
                            <TabPanel value={this.state.value} index={0}>
                              <Grid key={"searchBox"} className="searchbar-right" item sm={12}>
                                {/* <SearchBox
                                  autocompleteMinimumCharacters={3}
                                  autocompleteSuggestions={true}
                                  searchAsYouType={true}
                                  shouldClearFilters={false}
                                  inputProps={{ placeholder: t("WebCode") }}
                                /> */}
                                <SearchBox
                                  autocompleteMinimumCharacters={3}
                                  autocompleteSuggestions={true}
                                  searchAsYouType={true}
                                  shouldClearFilters={false}
                                  onSubmit={() => this.submitData(clearFilters, addFilter, setSort)}
                                  inputProps={
                                      { placeholder: t("WebCode") ,
                                        onKeyPress: (e) => this.onKeyPress(e,setSort)
                                      }
                                  }
                                />
                              </Grid>
                            </TabPanel>
                            <TabPanel value={this.state.value} index={1}>
                              <Grid key={"searchBox"} className="searchbar-right" item sm={12}>
                                {/* <SearchBox
                                  
                                  autocompleteMinimumCharacters={3}
                                  autocompleteSuggestions={true}
                                  searchAsYouType={true}
                                  shouldClearFilters={false}
                                  inputProps={{ placeholder: t("Text/Ref./Keywords") }}                                  
                                  
                                /> */}
                                <SearchBox
                                  autocompleteMinimumCharacters={3}
                                  autocompleteSuggestions={true}                                  
                                  shouldClearFilters={false}
                                  searchAsYouType={true}   
                                  
                                  onSelectAutocomplete={(selection, {}, defaultOnSelectAutocomplete) => {
                                    if (selection.suggestion && !selection.suggestion.startsWith('"')) {
                                      selection.suggestion='"'+selection.suggestion+'"';
                                      defaultOnSelectAutocomplete(selection);
                                    } else {
                                      defaultOnSelectAutocomplete(selection);
                                    }
                                  }}                                                         
                                  onSubmit={() => this.submitData(clearFilters, addFilter, setSort, resultSearchTerm)}
                                  inputProps={{ placeholder: t("Text/Ref./Keywords") ,
                                  onKeyPress:(e) => this.onKeyPress(e,setSort)}}
                                />
                              </Grid>
                            </TabPanel>
                          </Grid>
                          {/*<SearchBar
                          family={family}
                          family_list={familyName}
                          />*/}
                        </Grid>
                      </div>
                      <ClickAwayListener onClickAway={this.handleClickAway}>
                        <div id="searchBlock" className={localStorage.getItem('pinStatus')=='open' ? "searching-block pin-filter" : "searching-block"}>
                          <div className="filter-heading" onClick={() => this.openSearchBlock('searchBlock')}>
                            <Trans>SEARCHING IN</Trans>: {family ? family_list[family] : t('ALL FAMILIES')}
                            <i className="filter-icon">
                              <img src={`/img/svgs/${family ? family : 'family'}.svg`} alt="family" />
                            </i>
                            <span className="more-filter">
                              <Trans>Select a family to show more filter options</Trans>
                            </span>
                            <i className="down-arrow">
                              <img src="/img/svgs/down-arrow.svg" alt="down-arrow" />
                            </i>
                          </div>
                          <div className="filter-content">
                            <FamilySelector facets={facets} lang={lang} logged={logged} family_list={family_list} family_friend_list={family_friend_list} family={family} family_filters={family_filters} searchTerm={resultSearchTerm} trackUrlState={trackUrlState}/>

                            <i className="pin-icon" onClick={() => this.openPinBlock('searchBlock')}>
                              <img src="/img/svgs/pin.svg" alt="pin-icon" />
                            </i>
                          </div>
                        </div>
                      </ClickAwayListener>
                    </div>

                  }
                  sideContent={
                    <React.Fragment>
                      <div className="sidebar-toggle-close" onClick={this.hideSidebarFilter}></div>
                      <div className="filterleft-side">
                        <button className="btn gray-btn hideBtn" onClick={this.addFilterClass}><Trans>Hide filters</Trans></button>
                        {/* <button className="btn show-filter">Show filters</button>                                */}
                        <ResetButton
                          addFilter={addFilter}
                          clearFilter={clearFilters}
                          searchMode={this.state.searchMode}
                        ></ResetButton>
                        
                      </div>
                      {/*
                      <Button
                        variant="contained"
                        onClick={() => this.handleFilterVisibility()}
                        className="blue-btn toggle-filter-btn"
                      >
                        <Trans>Toggle filters menu</Trans>
                      </Button>
                      */}
                      {/* <br /> */}

                      <React.Fragment>

                        {/* <br /><br /> */}

                        {show_filters && (
                          <div>
                            {/* <br /><br /> */}
                            <CustomFacet
                              field="main_color"
                              label={t("Main color only")}
                              filterType="any"
                              view={BooleanFacet}
                            />
                            <CustomFacet
                              field="not_discontinued"
                              label={t("Hide discontinued")}
                              filterType="any"
                              view={BooleanFacet}
                            />
                            <CustomFacet
                              mapContextToProps={context => {
                                if (!context.facets.manufacturer) return context;
                                return {
                                  ...context,
                                  facets: {
                                    ...(context.facets || {}),
                                    manufacturer: context.facets.manufacturer.map(s => ({
                                      ...s,
                                      data: s.data.sort((a, b) => {
                                        if (a.value > b.value) return 1;
                                        if (a.value < b.value) return -1;
                                        return 0;
                                      })
                                    }))
                                  }

                                };
                              }}
                              field="manufacturer"
                              label={t("Manufacturers")}
                              filterType="any"       
                              customField={customFilterManufacturer}                              
                              view={MultiCheckboxFacetTrans}                              
                              isFilterable={true}
                              searchPlaceholder={t("Manufacturer_name")}
                            />
                            {/*TEST <Facet
                              field="in_offer"
                              label={t("In offer")}
                              filterType="any"
                              view={BooleanFacet}
                            />*/}
                            {/*TEST <Facet
                              field="stock"
                              label={t("Stock available")}
                              filterType="any"

                            />*/}
                            {/*TEST <Facet
                              field="is_knx"
                              label={t("Is KNX")}
                              filterType="any"
                              view={BooleanFacet}
                            />
                            <Facet
                              field="in_showroom"
                              label={t("In showroom")}
                              filterType="any"
                              view={BooleanFacet}
                            /> */}

                            <CustomFacet
                              field="common"
                              label={t("common")}
                              filterType="any"
                              show={10}
                              view={MultiCheckboxFacetCommon}
                            />

                            <CustomFacet
                              field="color"
                              label={t("color")}
                              filterType="any"
                              view={MultiCheckboxFacetTrans}
                              isFilterable={true}
                              searchPlaceholder={t("Color_name")}
                            />
                            <CustomFacet
                              field="manufacturer_series"
                              label={t("manufacturer_series")}
                              filterType="any"
                              view={MultiCheckboxFacetTrans}
                              searchPlaceholder={t("Series_name")}
                              isFilterable={true}
                            />
                            <CustomFacet
                              field="price_group"
                              label={t("price_group")}
                              filterType="any"
                              view={MultiCheckboxFacetTrans}
                              isFilterable={true}
                              searchPlaceholder={t("price_group")}
                            />
                            {/* <br /> */}
                            {/* <FamilySelector lang={lang} logged={logged} family_list={family_list} family={family} family_filters={family_filters} searchTerm={searchTerm} /> */}
                            {/* <br /> */}

                            {<FiltersMenu lang={lang} logged={logged} family_list={family_list} family={family} config={config} family_filters={family_filters} label_list={label_list} /> }
                          </div>
                        )}
                      </React.Fragment>

                    </React.Fragment>
                  }

                  bodyContent={
                    <React.Fragment>
                    
                      <TopBanner config={config} languageId={languageId} jwt={jwt} api_url={api_url}></TopBanner>                    
                      <App
                        familySortOnInit={familySortOnInit}
                        data={results}
                        lang={lang}
                        logged={logged}
                        express={express}
                        tariff={tariff}
                        client_country_id={client_country_id}
                        cart_products={cart_products}
                        fav_products={fav_products}
                        jwt={jwt}
                        typeView={typeView}
                        onChangeView={this.handleView}
                        sortDirection={sortDirection}
                        sortField={sortField}
                        price_sort={price_sort}
                        current={current}
                        current_page={current_page}
                        setCurrent={setCurrent}
                        addFilter={addFilter}
                        clearFilter={clearFilters}
                        family={family}
                        family_list={family_list}
                        searchMode={this.state.searchMode}
                        onSortChange={(data, direction) => this.onSortingChange(data, sortField, setSort, direction)}
                        mainHeight={(data) => this.mainSectionHeight(data)}
                        resultSearchTerm={resultSearchTerm}
                        api_url={api_url}
                        setDefaultOrder={() => this.setDefaultOrder(setSort)} 
                        customFilterManufacturerIds={customFilterManufacturerIds}
                        customFilterManufacturer={customFilterManufacturer}
                      />
                      
                      {/* <SearchBanner banner={banner} /> */}
                      <Card className={`${classes.root} bannerText advertise-banner`}>
                        {/* {
                          this.state.bannerList.map((item, index) => {
                            return(
                              <div key={item.id}>
                                {`banner ${index}`}
                              </div>
                            )
                          })
                        } */}
                        <div className="manufacturer-links-wrapper" style={width > 991 ? { height: mainH, overflow: 'hidden' } : { height: 'auto', overflow: 'unset' }}>
                          {
                            this.state.bannerList.map((item, index) => {
                              if (item.is_video == "0") {
                                return (
                                  <div className="manufacturer-link-inner" key={item.id} ref={this.setRef}>
                                    <em>
                                      <a className="d-block" href={item.url} target="_blank" >
                                        <img src={item.image} alt={item.title}
                                          onError={(e) => { e.target.onerror = null; e.target.src = "/common/fotos/default.png" }}
                                        />
                                      </a>
                                    </em>
                                  </div>
                                )
                              } else if (item.is_video == "1") {
                                return (
                                  item.url !== null &&
                                  <div className="manufacturer-link-inner" key={item.id}>
                                    <em>
                                      <iframe src={item.url}
                                        allow='autoplay;fullscreen;encrypted-media'
                                        allowFullScreen=""
                                        title='video'
                                        style={dimensions?.width ? { height:dimensions.width * 1.69}:{}}
                                      />
                                    </em>
                                  </div>
                                )
                              }
                            })
                          }
                          {/*<div className="manufacturer-link-inner">
                            <em>
                              <a className="d-block" target="_blank">
                                <iframe src="http://www.youtube.com/embed/M7lc1UVf-VE?enablejsapi=1&origin=http://example.com" frameborder="0" allow="autoplay;fullscreen" allowfullscreen></iframe>
                              </a>
                            </em>
                        </div>*/}
                        </div>
                        {/* <CardActionArea className="banner-action">                                                   
                          <CardMedia
                            component="img"
                            className={classes.media}
                            height="auto"
                            image={banner}
                            title="Search Banner"
                          />
                        </CardActionArea> */}
                      </Card> 
                    </React.Fragment>
                  }
                  bodyHeader={
                    <React.Fragment>
                      <div className="filter-result">
                        {/*<SelectedFilters onShowFilter={this.showHideFilters}></SelectedFilters>*/}
                        <SelectedFiltersComp onShowFilter={this.showHideFilters} lang={lang} logged={logged} family_list={family_list} family={family} config={config} family_filters={family_filters} label_list={label_list}></SelectedFiltersComp>
                        {/* <li><button>Hide discontinued<span><img src="close-icon" /></span></button></li>
                            <li><button>Hide discontinued<span><img src="close-icon" /></span></button></li>
                            <li><button>Hide discontinued<span><img src="close-icon" /></span></button></li> */}
                      </div>
                      <div className="pagination-block">
                        {wasSearched && <PagingInfo
                          view={({ start, end, totalResults }) => (
                            <div className="paging-wrapper">
                              <div className="paging-info">
                                <Trans>Showing</Trans> <strong>{start} - {end}</strong> <Trans>out of</Trans> <strong>{totalResults}</strong>
                              </div>
                              <div className="selectbox-wrapper">
                                {wasSearched && (
                                  <PriceSortingSelector
                                    lang={lang}
                                    logged={logged}
                                    price_sort={price_sort}
                                    current={current}
                                    setPriceSorting={this.handlePriceSorting}
                                  />
                                )}

                                <div className="paging-info-right">
                                  {wasSearched &&
                                    <Sorting sortOptions={sort_options} className="select-box" />

                                    /** <ResultsPerPage options={['Orden por: Seleccione', 40, 60, 100, 200, 500, 1000]} /> */
                                  }
                                  {wasSearched && (
                                    <FormControl className={`${classes.formControl + " " + classes.labelZIndez} sorting-direction select-box`}>
                                      <Select
                                        id="demo-simple-select-outlined"
                                        value={sorting_dropdown}
                                        onChange={(e) => this.handleDirectionChange(e, sortField, setSort)}
                                        label={t("Direction")}
                                        name="sorting_dropdown"
                                      >
                                        <MenuItem value={"asc"}>{t("Ascending")}</MenuItem>
                                        <MenuItem value={"desc"}>{t("Descending")}</MenuItem>
                                      </Select>
                                    </FormControl>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        />}
                        <div className="paging-right">
                          <div className="paging-right-btn">
                            <IconButton
                              aria-label="grid-view"
                              onClick={() => this.handleChangeView('grid')}
                              className="grid-icon"
                            >
                              <ViewComfyIcon />
                            </IconButton>
                            <IconButton
                              aria-label="list-view"
                              onClick={() => this.handleChangeView('list')}
                              className="list-icon"
                            >
                              <ViewListIcon />
                            </IconButton>
                            <IconButton
                              aria-label="table-view"
                              onClick={() => this.handleChangeView('table')}
                              className="table-icon"
                            >
                              <FormatListNumberedRtlIcon />
                            </IconButton>
                          </div>
                          {wasSearched && <ResultsPerPage options={[20, 40, 60, 100, 200, 500, 1000]} />}
                          <ShareButton
                          searchMode={this.state.searchMode}                          
                          family={this.state.family}
                          price_sort={this.state.price_sort}       
                          typeView={this.state.typeView}  
                          current_page={this.state.current_page}     
                          sortDirection={sortDirection}
                          sortField={sortField}
                          current={current}
                          resultSearchTerm={resultSearchTerm}            
                        ></ShareButton>
                        </div>
                      </div>
                    </React.Fragment>
                  }
                  bodyFooter={<Paging />}
                />

              </ErrorBoundary>
            </div>
          )}
        </WithSearch>
      </SearchProvider>
    </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(ResultsRenderer));
